<div [ngClass]="{'wysiwyg-invalid': control && control.invalid && control.touched}">
  <swb-wysiwyg *ngIf="field.wysiwyg" [key]="field.key" [height]="field.height" [formControl]="control" [ident]="field.wysiwyg"
    [initValue]="field.value" [control]="control"></swb-wysiwyg>

  <textarea *ngIf="!field.wysiwyg" [formControl]="control" [id]="field.key" [style.minHeight.px]="expanded ? field.height : 0"
    [ngClass]="{'expanded': expanded}" (focus)="expand($event)" (blur)="shrink($event)"></textarea>
</div>